import { render, staticRenderFns } from "./mdBackListAction.vue?vue&type=template&id=1c795848&scoped=true"
import script from "./mdBackListAction.vue?vue&type=script&lang=js"
export * from "./mdBackListAction.vue?vue&type=script&lang=js"
import style0 from "./mdBackListAction.vue?vue&type=style&index=0&id=1c795848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c795848",
  null
  
)

export default component.exports